import {makeAutoObservable} from 'mobx';

export class LoaderStore {
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoading = (value: boolean) => {
    this.isLoading = value;
  };

  startLoading = () => {
    this.setIsLoading(true);
  };

  stopLoading = () => {
    this.setIsLoading(false);
  };
}
